export default function AboutSection() {
  return (
    <section id="about" className="py-16 sm:py-20 bg-gradient-to-br from-gray-50 to-purple-50 scroll-mt-16 sm:scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
            会社概要
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto px-4 text-center">
            信頼できる情報流通を実現する技術で、安心できる社会の構築を目指します
          </p>
          
          {/* 添付画像を中央配置 */}
          <div className="mt-8 sm:mt-12 flex justify-center">
            <div className="w-full max-w-[120px]">
              <img 
                src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/1ef77049b239721be43b45786556c0f0.png"
                alt="会社概要イメージ"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* 筑波大学発ベンチャーの文章 */}
          <div className="mt-6 sm:mt-8">
            <p className="text-sm sm:text-base text-gray-700 font-medium">
              株式会社ソーシャルパスは、2025年12月 筑波大学発ベンチャーの称号を授与されました。
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
          <div className="space-y-4 sm:space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-start border-b border-gray-200 pb-4 sm:pb-6">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-building-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">会社名</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left">
                株式会社ソーシャルパス<br />
                Social Path Co.,Ltd.
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start border-b border-gray-200 pb-4 sm:pb-6">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-calendar-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">設立</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left">2025年3月</dd>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start border-b border-gray-200 pb-4 sm:pb-6">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-user-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">代表者</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left">代表取締役 三村 昌裕</dd>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start border-b border-gray-200 pb-4 sm:pb-6">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-map-pin-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">所在地</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left">東京都中央区佃1-11-7</dd>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start border-b border-gray-200 pb-4 sm:pb-6">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-briefcase-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">事業内容</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left">
                情報の真正性検証技術の研究開発およびサービスの提供<br />
                環境固有性NFT・ロバストネスNFTの活用およびサービスの提供<br />
                情報セキュリティソリューションの提供
              </dd>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-start">
              <div className="flex items-center mb-2 sm:mb-0 sm:w-48 flex-shrink-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-white text-lg sm:text-xl"></i>
                </div>
                <dt className="font-bold text-gray-900 text-sm sm:text-base">お問い合わせ</dt>
              </div>
              <dd className="text-gray-600 flex-1 text-sm sm:text-base text-left sm:text-left break-all">
                <a href="mailto:info@socialpath.tech" className="text-purple-600 hover:text-purple-700 transition-colors">
                  info@socialpath.tech
                </a>
              </dd>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
